<template>
  <div class="pinglun-list">
    <div class="big-title">
      {{ listTitle }} ({{total}})
      <div class="paixu">
        <span
          :class="{ active: commonParam.order === 'time' }"
          @click="orderType('time')"
          ><i class="el-icon-sort"></i>时间</span
        >
        <span
          :class="{ active: commonParam.order === 'hot' }"
          @click="orderType('hot')"
          ><i class="el-icon-sort"></i>热度</span
        >
      </div>
    </div>
    <ul class="pl-list">
      <div v-for="(item, index) in listDate" :key="index">
        <talk-third
          :obj="item"
          v-if="isReload"
          :isProView="isProView"
          :loadShow="loadShow"
        ></talk-third>
      </div>
      <div class="see-more" @click="getFather" v-if="showMore">更多回复</div>

      <!--      <talk-third></talk-third>-->
      <!--      <talk-third></talk-third>-->
      <!--      <pagination  v-show="total>0" :total="total" :page.sync="commonParam.pageIndex" :limit.sync="commonParam.pageSize"-->
      <!--                  :pageSizes="commonParam.pageSizes"  @pagination="getFather" style="text-align: center"/>-->
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
import talkThird from '@@/pub/talkthird/talkthird'
import commentApi from '@/api/comment'
// import Pagination from '@/components/Pagination'

export default {
  props: {
    listTitle: {
      type: String,
      default: '用户评论'
    },
    objType: {
      type: Number,
      required: true,
    },
    objId: {
      type: Number,
      required: true,
    },
    commentAuthorRankId: {
      type: Number,
      required: true,
    },
    isProView:{
      type:Boolean
    }
    ,
    loadShow:{
      type:Boolean
    }

  },
  components: {
    talkThird
  },
  data () {
    return{
      isReload:true,
      showMore:true,
      total:0,
      listDate:[],
      isLogin:false,
      commonParam:{
        commentObjectId:this.objId,
        commentObjectType:this.objType,
        commentAuthorRankId:this.commentAuthorRankId,//评论者等级id 大于1为专家//0为普通
        commentParent:0,//0为父级评论
        pageIndex: 1,
        pageSize: 5,
        order:'time',
      },
    }
  },
  mounted() {

    this.getFather();

  },
  methods:{
    getFather(){
      let this_ = this

      commentApi.getPageList(this_.commonParam).then(reFather => {
        reFather.list.forEach((item) => {
          //console.log("item.id====",item.id)
          this_.listDate.push(item)
        })

        //console.log("this_.listDate=oo========",this_.listDate)

        this_.total = reFather.total
        if(this_.commonParam.pageIndex == Math.ceil(this_.total/this_.commonParam.pageSize)){
          this_.showMore =false
        }else{
          this_.commonParam.pageIndex = this.commonParam.pageIndex +1
        }

        // 移除组件
        this_.isReload = false

        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this_.$nextTick(() => {
          this_.isReload = true
        })

        if(this_.listDate.length ==0){
          this_.$parent.hideTalk(this_.commentAuthorRankId);
        }

      })
    },
    setEmpty(){
      this.listDate = []
      this.commonParam.pageIndex=1
      this.showMore=true,
      this.total=0,
      this.getFather();
    },
    orderType(type){
      // 移除组件
      this.isReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.isReload = true
      })
      if(this.listDate.length ==0){
        this.$parent.hideTalk(this.commentAuthorRankId);
      }
      this.commonParam.order = type
      this.commonParam.pageIndex=1
      this.showMore=true
      this.listDate=[]
      this.getFather()
    },
    setAddCommentNum(){
      this.$parent.addCommentNum()
    },
    setDelCommentNum(cutNum){
      this.$parent.delCommentNum(cutNum)
    }
  }
}
</script>

<style scoped lang="less">
.see-more {
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  &:hover {
    color: #409eff;
    text-decoration: underline;
  }
}
</style>
